import React from 'react';
import {
  Card,
  Typography,
  Box,
  Chip,
  Grid,
} from '@mui/material';

const ActiveBookLottery = ({ activeGame = [] }) => {
  const hasData = Array.isArray(activeGame) && activeGame.length > 0;

  return (
<Box
  sx={{
    display: 'flex',
    flexWrap: 'wrap',             
    justifyContent: 'center',     
    alignItems: 'flex-start',
    gap: 2,
    paddingY: 1,
    paddingX: 0.5,
  }}
>


      <Card
        sx={{
          width: '100%',
          padding: 2,
          borderRadius: 3,
          backgroundColor: '#fff',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
          border: '1px solid #eee',
          display: 'flex',
          flexDirection: 'column',
            justifyContent: 'center',
        }}
      >
        <Typography variant="h6" fontWeight={600} mb={2} textAlign="center">
          Active Lottery Tickets
        </Typography>

        {hasData ? (
          <Box
            sx={{
              display: 'flex',
              overflowX: 'auto',
              gap: 2,
              paddingY: 1,
              paddingX: 0.5,
            }}
          >
            {activeGame.map((ticket, index) => (
              <Card
                key={index}
                sx={{
                  minWidth: 200,
                  maxWidth: 220,
                  flex: '0 0 auto',
                  padding: 2,
                  border: '1px solid #E0E0E0',
                  borderRadius: 2,
                  backgroundColor: '#FAFAFA',
                }}
              >
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Typography fontWeight={500} fontSize={14}>Game No</Typography>
                    <Typography variant="body2">{ticket.game_no}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography fontWeight={500} fontSize={14}>Game Name</Typography>
                    <Typography variant="body2">{ticket.game_name}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography fontWeight={500} fontSize={14}>Price</Typography>
                    <Typography variant="body2">${ticket.game_price}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography fontWeight={500} fontSize={14}>Status</Typography>
                    <Chip
                      label={ticket.status}
                      size="small"
                      color={ticket.status === 'Active' ? 'success' : 'default'}
                    />
                  </Grid>
                </Grid>
              </Card>
            ))}
          </Box>
        ) : (
          <Box
            sx={{
              textAlign: 'center',
              color: '#999',
              fontStyle: 'italic',
              paddingY: 4,
            }}
          >
            No Active Lottery Tickets Available
          </Box>
        )}
      </Card>
    </Box>
  );
};

export default ActiveBookLottery;
